<template>
	<div class="w-full flex-col items-center">
		<ToolBar>
			<div
				id="local-toolbar"
				class="w-full flex items-center gap-3 proceedings-toolbar-layout"
			>
				<div class="form-check proceedings-select-all">
					<input
						id="select-all-proceedings"
						type="checkbox"
						:checked="isAllSelected"
						hidden
						@change="ToggleAllSchedulings($event.target.checked)"
					/>
					<label
						for="select-all-proceedings"
						class="form-check-label"
					></label>
				</div>

				<div class="w-full h-full position-relative">
					<button
						id="cancel-btn"
						class="btn btn-fixed-size btn-danger px-4 proceedings-cancel-btn"
						:disabled="selected.schedulings.length === 0"
						@click="Cancel()"
					>
						CANCELAR
					</button>
					<button
						id="payment-btn"
						class="btn btn-light btn-fixed-size px-4 proceedings-payment-btn"
						:disabled="!canConfirm"
						@click="OpenPaymentMethodsModal()"
					>
						PAGAMENTO
					</button>
					<button
						id="confirm-btn"
						class="btn btn-fixed-size btn-success px-4 proceedings-confirm-btn"
						:disabled="!canConfirm"
						@click="Confirm()"
					>
						CONFIRMAR
					</button>
				</div>
			</div>
		</ToolBar>

		<MainContent class="pt-4">
			<div
				v-for="journey in journeys"
				:key="`${journey.id}-${journey.schedule.id}`"
				class="w-full flex-col items-center justify-center"
			>
				<div
					v-for="scheduling in items.filter(
						s => s.journey_id === journey.id && s.schedule.id === journey.schedule.id
					)"
					:key="`${journey.id}-${journey.schedule.id}-${scheduling.id}`"
					class="w-full"
					:journey_id="scheduling.journey_id"
					:schedule_id="scheduling.schedule_id"
				>
					<div
						class="card mb-4"
						:class="[
							selected.schedulings.indexOf(scheduling.id) > -1 ? 'selected' : '',
							scheduling.attendance.status === 11 ? 'no-show' : '',
						]"
					>
						<div
							class="card-body p-4"
							@click.self="ClickOnInput(scheduling.id)"
						>
							<div
								class="w-full flex mb-3"
								@click="ClickOnInput(scheduling.id)"
							>
								<div class="w-auto h-1 pr-1 pt-1">
									<div class="form-group m-0 form-check">
										<input
											:id="`scheduling-${scheduling.id}`"
											v-model="selected.schedulings"
											type="checkbox"
											:value="scheduling.id"
										/>
										<label
											:for="`scheduling-${scheduling.id}`"
											@click="ClickOnInput(scheduling.id)"
										></label>
									</div>
								</div>
								<div class="w-full pl-0 pr-4">
									<p class="proceeding-name">
										{{ scheduling.proceeding.nome }}
									</p>
									<div
										v-if="scheduling.proceeding.tuss"
										class="font-14 mb-4"
									>
										{{ scheduling.proceeding.tuss.codigo }}
										-
										{{ scheduling.proceeding.tuss.terminologia }}
									</div>
								</div>
								<div v-if="scheduling.attendance.status == 11">
									<div class="no-show-label">
										{{ scheduling.attendance.status_descricao.toUpperCase() }}
									</div>
								</div>
							</div>
							<div
								class="w-full d-flex justify-content-start gap-4 mb-3 proceeding-data"
								@click="ClickOnInput(scheduling.id)"
							>
								<div>
									<span class="info-label">DATA: </span>
									<span class="info-data">{{ scheduling.data }}</span>
								</div>
								<div>
									<span class="info-label">HORÁRIO: </span>
									<span class="info-data">{{ scheduling.hora }}</span>
								</div>
								<div>
									<span class="info-label">AGENDA: </span>
									<span class="info-data">{{ scheduling.schedule.nome }}</span>
								</div>
							</div>
							<div
								class="w-full proceedings-actions-row"
								style="height: 2.625rem"
							>
								<div class="flex h-full gap-2 flex-nowrap proceedings-actions-left">
									<button
										class="btn btn-fixed-size btn-danger"
										@click="Cancel([scheduling])"
									>
										CANCELAR
									</button>
									<button
										class="btn btn-fixed-size btn-no-response"
										@click="ReSchedule([scheduling])"
									>
										REAGENDAR
									</button>
									<button
										class="btn btn-fixed-size btn-pending"
										:disabled="scheduling.attendance.status !== 11"
										@click="Fit(scheduling)"
									>
										ENCAIXAR
									</button>
								</div>
								<div class="flex h-full gap-2 flex-nowrap proceedings-actions-center">
									<button
										class="btn btn-fixed-size"
										:class="[
											IsProceedingDataValid(scheduling) ? '' : 'btn-warning',
											ShouldBlinkPartnershipButton(scheduling) ? 'btn-warning-blink' : '',
										]"
										@click.prevent="OpenProceedingDataModal(scheduling)"
									>
										{{ GetPartnershipButtonLabel(scheduling) }}
									</button>
									<button
										class="btn btn-fixed-size"
										:disabled="true"
									>
										PAGAMENTO
									</button>
									<FormGroup
										v-model="scheduling.billing.factor"
										formatter="factor"
										class="col-span-3 factor"
										label="FATOR"
										placeholder="1,00"
										:omit-info="true"
										:required="false"
										@blur="NormalizeFactor(scheduling)"
									/>
								</div>
								<div class="flex h-full gap-2 justify-end proceedings-actions-right">
									<button
										class="btn btn-fixed-size btn-success"
										:disabled="
											scheduling.attendance.status === 11 || !IsProceedingDataValid(scheduling)
										"
										@click="Confirm(scheduling)"
									>
										CONFIRMAR
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</MainContent>

		<IndicatorModal @indicator="SetIndicator" />

		<PaymentMethodsModal
			:total="total_proceedings"
			@payment-methods-added="PaymentMethodsHandler"
		/>

		<PartnershipsModal
			v-if="proceedingDataModal.show && proceedingDataModal.scheduling"
			:partnerships-props="GetPartnershipsProps(proceedingDataModal.scheduling)"
			:patient="patient"
			@save="SaveProceedingDataModal"
			@close="CloseProceedingDataModal"
		/>
	</div>
</template>

<script>
	const _ = require('lodash')
	import Swal from 'sweetalert2'
	import { mapGetters } from 'vuex'
	import { useDeleteAlert } from '@/composables'

	import IndicatorModal from '@/components/shared/indicator/IndicatorModal.vue'
	import PaymentMethodsModal from '@/components/shared/payment/PaymentMethodsModal.vue'
	import PartnershipsModal from './PartnershipsModal.vue'
	export default {
		name: 'Proceedings',
		props: {
			schedulings: {
				type: Array,
				default: () => [],
			},
			patient: {
				type: Object,
				default: null,
			},
		},
		components: {
			PaymentMethodsModal,
			IndicatorModal,
			PartnershipsModal,
		},
		data() {
			return {
				items: [],
				selected: {
					schedulings: [],
					journey_id: null,
					payment_methods_info: null,
					indicator: null,
				},
				form_invalid: false,
				validations_form: [],
				attemptedSubmit: false,
				proceedingDataModal: {
					show: false,
					scheduling: null,
				},
				allProceedingsSelected: false,
			}
		},
		validations: {
			items: {
				$each: {},
			},
		},
		computed: {
			...mapGetters('auth', ['requester_selected_object']),
			hasnt_missing_schedulings() {
				let allowed = true

				if (this.selected.schedulings.length > 0) {
					allowed = false

					this.selected.schedulings.forEach(s => {
						let tmp = this.items.find(item => s == item.id)

						if (tmp && tmp.attendance.status == 11) {
							//FALTA
							allowed = true

							return
						}
					})
				}

				return allowed
			},
			journeys() {
				const journeys = []

				this.items.forEach(scheduling => {
					const journey_index = journeys.findIndex(j => j.id === scheduling.journey_id)

					let journey = null

					if (journey_index === -1) {
						journey = {
							...scheduling.journey,
							quantity: 1,
							schedule: scheduling.schedule,
						}

						journeys.push(journey)
					} else {
						if (journeys[journey_index]?.schedule.id != scheduling.schedule.id) {
							journey = {
								...scheduling.journey,
								quantity: 1,
								schedule: scheduling.schedule,
							}

							journeys.push(journey)
						} else {
							journeys[journey_index].quantity++
						}
					}
				})

				return _.orderBy(journeys, ['schedule.nome'], 'asc')
			},
			total_proceedings() {
				let value = 0

				const schedulings = this.items.filter(item => this.selected.schedulings.indexOf(item.id) > -1) ?? []

				if (!schedulings.length) return value

				value = schedulings.reduce((acc, scheduling) => {
					const proceeding = scheduling.proceeding
					const partnershipId = scheduling.selected_partnership?.id ?? scheduling.partnership?.id

					if (!partnershipId) return acc

					const matched = (proceeding.partnerships || []).find(p => p.id == partnershipId)

					if (!matched?.pivot) return acc

					return acc + Number(matched.pivot.valor)
				}, 0)

				return value
			},
			indicatorValid() {
				const isMandatoryIndicator = this.requester_selected_object?.instance?.config?.indicator_doctor

				if (isMandatoryIndicator) {
					return this.selected.indicator
				}

				return true
			},
			isAllProceedingDataValid() {
				if (this.selected.schedulings.length === 0) return true
				return this.items
					.filter(s => this.selected.schedulings.indexOf(s.id) > -1)
					.every(s => this.IsProceedingDataValid(s))
			},
			canConfirm() {
				return !this.hasnt_missing_schedulings && this.isAllProceedingDataValid
			},
			hasUnselectedPartnerships() {
				if (this.selected.schedulings.length === 0) return false
				return this.items
					.filter(s => this.selected.schedulings.indexOf(s.id) > -1)
					.some(s => !s.selected_partnership?.id)
			},
			isAllSelected() {
				if (!this.items.length) return false
				return this.selected.schedulings.length === this.items.length
			},
		},
		watch: {
			schedulings: {
				handler(val) {
					if (val.length > 0) {
						this.items = val.map(item => ({
							...item,
							billing: this.FormatBillingForDisplay(item.billing),
							selected_partnership: {
								...(item.selected_partnership || item.partnership || {}),
							},
							invalid_selected_partnership_name: null,
							available_partnerships: null,
						}))

						const validIds = this.items.map(item => item.id)
						this.selected.schedulings = this.selected.schedulings.filter(id => validIds.indexOf(id) > -1)

						this.selected.indicator = this.items[0]?.indicator_doctor ?? null
						this.LoadAvailablePartnerships()
					} else {
						this.items = []
						this.selected.schedulings = []
					}
				},
				immediate: true,
			},
			'selected.schedulings': {
				handler(val) {
					this.items = this.items.map(item => {
						item.selected = false

						return item
					})

					if (val.length > 0) {
						val.forEach(scheduling_id => {
							let find = _.findIndex(this.items, ['id', scheduling_id])

							if (find > -1) {
								this.items[find].selected = true
							}
						})
					}

					this.$emit('all-selected-change', this.isAllSelected)
				},
			},
			canConfirm: {
				handler(val) {
					this.$emit('can-confirm-change', val)
				},
				immediate: true,
			},
			'selected.indicator': {
				handler(val) {
					this.$emit('indicator-change', val)
				},
				immediate: true,
			},
		},
		methods: {
			ShouldBlinkPartnershipButton(scheduling) {
				return !!scheduling?.invalid_selected_partnership_name
			},
			GetPartnershipButtonLabel(scheduling) {
				const name = scheduling?.selected_partnership?.nome

				if (name) return String(name).toUpperCase()
				if (scheduling?.invalid_selected_partnership_name)
					return String(scheduling.invalid_selected_partnership_name).toUpperCase()

				return 'SELECIONE OUTRO CONVÊNIO'
			},
			ToggleAllSchedulings(checked) {
				if (checked) {
					this.selected.schedulings = this.items.map(item => item.id)
					return
				}

				this.selected.schedulings = []
			},
			IsValidForm() {
				const isValid = this.items
					.filter(s => this.selected.schedulings.indexOf(s.id) > -1)
					.map(s => this.IsProceedingDataValid(s))
					.every(isValid => isValid)

				if (!this.indicatorValid) {
					this.attemptedSubmit = true

					Swal.fire({
						icon: 'error',
						title: 'SOLICITANTE OBRIGATÓRIO',
						text: 'É OBRIGATÓRIO SELECIONAR UM SOLICITANTE ANTES DE CONTINUAR!',
						showConfirmButton: true,
						customClass: {
							container: 'themed',
						},
					})

					return false
				}

				return isValid
			},
			ValidateItem(item) {
				if (item) {
					return false
				}
				return true
			},
			UpdateState(scheduling_id) {
				const el = document.querySelector(`#scheduling-${scheduling_id}`)

				this.form_invalid = false

				el.click()
				el.click()
			},
			async Confirm(scheduling = null) {
				let schedulingsToConfirm = []

				if (scheduling) {
					schedulingsToConfirm = [scheduling]
				} else if (this.selected.schedulings.length > 0 && this.IsValidForm()) {
					schedulingsToConfirm = this.items.filter(s => this.selected.schedulings.indexOf(s.id) > -1)
				} else {
					if (!this.indicatorValid) return

					const arr = document.getElementsByClassName('is-invalid')

					for (let key in arr) {
						const input = arr[key]

						if (input) {
							Swal.fire({
								icon: 'error',
								title: 'PREENCHA OS CAMPOS OBRIGATÓRIOS',
								toast: true,
								position: 'top',
								timer: 4000,
								timerProgressBar: true,
								customClass: {
									container: 'themed',
								},
							})

							input?.focus()
							break
						}
					}

					return
				}

				if (schedulingsToConfirm.length > 0) {
					const schedulings = schedulingsToConfirm.map(s => ({
						partnership_id: s.selected_partnership.id,
						id: s.id,
						billing: this.NormalizeBillingForApi(s.billing),
					}))
					this.$emit('next', {
						method: 'confirm',
						schedulings,
						payment_methods_info: this.selected.payment_methods_info,
						indicator: this.selected.indicator,
					})
				}
			},
			async Cancel(schedulings = null) {
				let schedulingsToCancel = []
				if (Array.isArray(schedulings) && schedulings.length && schedulings[0].id) {
					schedulingsToCancel = schedulings.map(s => ({ id: s.id }))
				} else {
					schedulingsToCancel = this.items
						.filter(s => this.selected.schedulings.indexOf(s.id) > -1)
						.map(s => ({ id: s.id }))
				}

				const vm = this

				if (schedulingsToCancel.length > 0) {
					const { isConfirmed } = await useDeleteAlert({
						title: 'DESEJA MESMO CANCELAR ESTE(S) AGENDAMENTO(S)?',
						html: 'DIGITE "DEL" NO CAMPO ABAIXO',
					})

					if (isConfirmed) {
						vm.$emit('next', {
							method: 'cancel',
							schedulings: schedulingsToCancel,
						})
					}
				}
			},
			Fit(scheduling) {
				this.$emit('next', {
					method: 'fit',
					schedulings: scheduling,
				})
			},
			ReSchedule(schedulings) {
				let fullSchedulings = []
				if (Array.isArray(schedulings) && schedulings.length && schedulings[0].id) {
					fullSchedulings = schedulings
				} else {
					fullSchedulings = this.items.filter(s => schedulings.indexOf(s.id) > -1)
				}
				this.$emit('next', {
					method: 'reschedule',
					schedulings: fullSchedulings,
				})
			},
			GetPartnership(event) {
				this.form_invalid = false

				const id = parseInt(event.target.id.replace('partnership-', ''))
				const partnership_id = parseInt(event.target.value)

				const indexElement = this.items.findIndex(el => el.id == id)

				if (indexElement === -1) return

				const element = this.items[indexElement]
				const partnership = element.proceeding.partnerships.find(el => el.id == partnership_id)

				if (!partnership) {
					this.form_invalid = true
					return
				}

				this.$set(this.items, indexElement, {
					...element,
					partnership: { ...partnership },
					selected_partnership: { ...partnership },
					invalid_selected_partnership_name: null,
					billing: { ...(element.billing || {}) },
				})
			},
			ClickOnInput(scheduling_id) {
				const already_set = this.selected.schedulings.indexOf(scheduling_id) > -1

				if (already_set) {
					this.selected.schedulings = this.selected.schedulings.filter(s => {
						return s != scheduling_id
					})
				} else {
					this.selected.schedulings.push(scheduling_id)
				}
			},
			SetIndicator(indicator) {
				this.selected.indicator = indicator

				this.HideIndicatorModal()
			},
			HideIndicatorModal() {
				window.jQuery('#indicator_modal').modal('hide')
				window.jQuery('body').removeClass('modal-open')
			},
			OpenModal(id) {
				window.jQuery(id).modal('show')
			},
			OpenIndicatorModal() {
				this.OpenModal('#indicator_modal')
			},
			OpenPaymentMethodsModal() {
				this.OpenModal('#payment-methods-modal')
			},
			PaymentMethodsHandler(payment_methods_info) {
				this.selected.payment_methods_info = payment_methods_info
			},
			IsProceedingDataValid(scheduling) {
				const partnership = scheduling.selected_partnership || {}
				const billing = scheduling.billing || {}
				const indicator = scheduling.indicator_doctor || null
				if (!partnership || !partnership.id) return false

				const validationCodeRequired = partnership.validation_code === true
				if (validationCodeRequired) {
					const validationCode = String(billing.validation_code ?? '').trim()
					const absenceJustification = String(billing.absence_justification ?? '').trim()

					if (!validationCode && !absenceJustification) {
						return false
					}
				}

				const requiredFields = {
					default: [],
					consultation: [
						'wallet_number',
						'plan_registration',

						'guardian_name',
						'guardian_cpf',
						'kinship_degree',
						'guardian_phone',

						'guide_number',
						'provider_guide_number',

						'attendance_type',
						'attendance_character',
						'regime',
						'consultation_type',
						'special_coverage',
						'occupational_health',
						'accident_indication',
						'cid',
						'observations',
					],
					sp_sadt: [
						'wallet_number',
						'wallet_validity',
						'plan_registration',

						'indicator',

						'guardian_name',
						'guardian_cpf',
						'kinship_degree',
						'guardian_phone',

						'guide_number',
						'authorization',
						'authorization_validity',
						'authorization_date',
						'validation_code',
						'absence_justification',
						'provider_guide_number',
						'main_guide_number',

						'request_date',
						'attendance_type',
						'attendance_character',
						'regime',
						'consultation_type',
						'special_coverage',
						'occupational_health',
						'accident_indication',
						'cid',
						'observations',
					],
				}

				for (const field of requiredFields[billing.guide_type]) {
					if (validationCodeRequired && (field === 'validation_code' || field === 'absence_justification')) {
						continue
					}

					if (!partnership[field]) continue

					if (field === 'indicator') {
						if (!indicator || !indicator.id) return false
						continue
					}

					const value = billing[field]
					if (value === null || value === undefined || String(value).trim() === '') {
						return false
					}
				}

				return true
			},
			async LoadAvailablePartnerships() {
				await Promise.all(
					this.items.map(async (item, index) => {
						const partnershipIds = (item.proceeding.partnerships || []).map(p => p.id)

						if (!item.proceeding?.id || !partnershipIds.length) {
							this.$set(this.items[index], 'available_partnerships', item.partnerships || [])
							return
						}

						const { data } = await window.api.call('post', '/check-allowed-partnerships', {
							proceeding_id: item.proceeding.id,
							partnership_ids: partnershipIds,
						})

						const allowedIds = (data?.allowed_partnerships ?? partnershipIds).map(id => parseInt(id))
						const filtered = (item.proceeding.partnerships || []).filter(p =>
							allowedIds.includes(parseInt(p.id))
						)
						this.$set(this.items[index], 'available_partnerships', filtered)

						const currentId = this.items[index].selected_partnership?.id
						if (currentId && !allowedIds.includes(parseInt(currentId))) {
							const invalidPartnershipName =
								this.items[index].selected_partnership?.nome ||
								this.items[index].partnership?.nome ||
								null

							this.$set(this.items[index], 'invalid_selected_partnership_name', invalidPartnershipName)
							this.$set(this.items[index], 'selected_partnership', {})
							this.$set(this.items[index], 'partnership', {})
						} else if (currentId) {
							this.$set(this.items[index], 'invalid_selected_partnership_name', null)
						}
					})
				)
			},
			GetAvailablePartnerships(scheduling) {
				return scheduling.available_partnerships ?? scheduling.partnerships ?? []
			},
			OpenProceedingDataModal(scheduling) {
				this.proceedingDataModal.show = true
				this.proceedingDataModal.scheduling = scheduling
			},
			CloseProceedingDataModal() {
				this.proceedingDataModal.show = false
				this.proceedingDataModal.scheduling = null
			},
			SaveProceedingDataModal({ partnership, billing, indicator }) {
				if (this.proceedingDataModal.scheduling) {
					const index = this.items.findIndex(item => item.id === this.proceedingDataModal.scheduling.id)
					if (index > -1) {
						this.$set(this.items[index], 'partnership', partnership)
						this.$set(this.items[index], 'selected_partnership', partnership)
						this.$set(this.items[index], 'billing', billing)
						this.$set(this.items[index], 'invalid_selected_partnership_name', null)
					}
				}

				if (indicator !== undefined) {
					this.selected.indicator = indicator
				}

				this.CloseProceedingDataModal()
			},
			GetPartnershipsProps(scheduling) {
				return {
					modality_id: scheduling.proceeding?.modality_id,
					schedulings: [scheduling],
					partnership: scheduling.selected_partnership,
					billing: scheduling.billing,
					indicator: this.selected.indicator,
					allowed_partnership_ids: (scheduling.available_partnerships || scheduling.partnerships || []).map(
						p => p.id
					),
				}
			},
			NormalizeFactor(scheduling) {
				let digits = String(scheduling?.billing?.factor ?? '')
					.replace(/\D/g, '')
					.slice(0, 3)

				if (!digits) {
					scheduling.billing.factor = null
					return
				}

				const number = parseInt(digits, 10) / 100

				if (number < 0.01 || number > 9.99) {
					scheduling.billing.factor = null
					return
				}

				scheduling.billing.factor = number.toFixed(2).replace('.', ',')
			},
			FormatBillingForDisplay(billing) {
				const normalized = { ...(billing || {}) }

				if (normalized.factor !== undefined && normalized.factor !== null && normalized.factor !== '') {
					const parsed = parseFloat(String(normalized.factor).replace(',', '.'))
					normalized.factor = Number.isFinite(parsed) && parsed !== 1
						? parsed.toFixed(2).replace('.', ',')
						: null
				}

				return normalized
			},
			NormalizeBillingForApi(billing) {
				if (!billing) return billing

				const normalized = { ...billing }

				if (normalized.factor === undefined || normalized.factor === null || normalized.factor === '') {
					normalized.factor = 1
				} else {
					const parsed = parseFloat(String(normalized.factor).replace(',', '.'))

					normalized.factor = Number.isFinite(parsed) ? parsed : 1
				}

				return normalized
			},
		},
		beforeMount() {
			if (this.items.length === 1) {
				this.selected.schedulings.push(this.items[0].id)
			}
		},
	}
</script>

<style lang="scss" scoped>
	.card {
		font-family: 'Avenir Next Light', sans-serif;
		background-color: var(--backgroundColor);
		border-color: var(--elementsBorderColor);
		border-radius: 1.5rem;

		.proceeding-name {
			font-size: 1.25rem;
			font-weight: bold;
			color: var(--fontColor);
			letter-spacing: 0.05rem;
			margin: 0;

			&:hover {
				color: var(--newPrimaryHoverColor);
			}
		}

		.proceeding-data {
			font-size: 0.875rem;
			color: var(--fontColor);
			letter-spacing: 0.05rem;
		}

		.info-label {
			color: var(--color-font-light);
		}

		.info-data {
			color: var(--fontColor);
			font-weight: bold;
		}

		&.selected {
			border-color: var(--newPrimaryColor) !important;
		}

		&.no-show {
			border-width: 0.188rem;
			border-color: var(--dangerBackgroundColor);

			.no-show-label {
				font-family: 'Inter', sans-serif !important;
				color: #ef4444;
				font-size: 1.5rem;
				font-weight: 900;
				letter-spacing: 0.1rem;
			}
		}
	}

	.split-journey {
		width: 100%;
		border: 0.05rem solid rgba(255, 255, 255, 0.185);
	}

	#remove-indicator {
		cursor: pointer;
	}

	.modal-dialog {
		max-width: 90%;
	}

	.modal-header {
		border-bottom-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	.btn-warning,
	.btn-warning-blink {
		background-color: var(--warning);
		border-color: var(--warning-hover);
		color: #ab7900;
	}

	.btn-warning:hover,
	.btn-warning-blink:hover,
	.btn-warning:active,
	.btn-warning-blink:active {
		background-color: var(--warning-hover);
		border-color: var(--warning-hover);
		color: #ab7900;
	}

	.btn-warning-blink {
		animation: warningBlink 1.1s ease-in-out infinite;
	}

	@keyframes warningBlink {
		0%,
		100% {
		}

		50% {
			background: transparent;
		}
	}

	.proceedings-actions-row {
		display: grid;
		grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
		align-items: center;
		gap: 0.5rem;
	}

	.proceedings-actions-left {
		justify-self: start;
	}

	.proceedings-actions-center {
		justify-self: center;
		transform: translateX(-2%);
		// transform: translateX(-25%);
	}

	.proceedings-actions-right {
		justify-self: end;
	}

	@media (max-width: 1360px) {
		.proceedings-actions-row {
			display: flex;
			align-items: center;
			flex-wrap: nowrap;
		}

		.proceedings-actions-left,
		.proceedings-actions-center,
		.proceedings-actions-right {
			flex: 0 0 auto;
		}

		.proceedings-actions-center {
			transform: none;
			margin-left: 0.5rem;
		}

		.proceedings-actions-right {
			margin-left: auto;
		}
	}

	#local-toolbar {
		height: 2.625rem;

		&.proceedings-toolbar-layout {
			position: relative;
			width: 100%;
			min-height: 2.5rem;

			.proceedings-select-all {
				position: absolute;
				left: 1rem;
				top: 50%;
				transform: translate(-50%, -50%);
				z-index: 10;
			}

			.proceedings-cancel-btn {
				position: absolute;
				left: 2.75rem;
				top: 50%;
				transform: translateY(-50%);
			}

			.proceedings-payment-btn {
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}

			.proceedings-confirm-btn {
				position: absolute;
				right: 0.5rem;
				top: 50%;
				transform: translateY(-50%);
			}
		}
	}

	.form-group {
		margin-bottom: 0;
	}

	.factor {
		display: flex;
		flex-wrap: wrap;
		align-content: center;
		margin-bottom: 0;
		gap: 2px;

		::v-deep .form-control {
			width: 5rem !important;
		}
	}
</style>
